// Thin fetch wrapper for the /api/v1/* Portal read-model. Same-origin in
// Docker (Nginx proxies /api to the API container); VITE_AIM_API_BASE is
// only set for local `npm run dev` against a bare API on another port.

const BASE = (import.meta as unknown as { env: Record<string, string> }).env
  .VITE_AIM_API_BASE || "";

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const res = await fetch(BASE + path, {
    signal,
    headers: { Accept: "application/json" },
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`${path} → HTTP ${res.status}`);
  return res.json() as Promise<T>;
}
